import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import Divider from '../Divider';
import Link from '../Link';
import StackView from '../StackView';

var _ref2 = /*#__PURE__*/React.createElement(Divider, {
  axis: "vertical",
  margin: 1,
  color: "grey-6"
});

function LinkList(_ref) {
  var links = _ref.links,
      restProps = _objectWithoutPropertiesLoose(_ref, ["links"]);

  return /*#__PURE__*/React.createElement(StackView, _extends({
    axis: "horizontal",
    alignment: "center",
    spacing: _ref2,
    wrap: true
  }, restProps), links.map(function (link) {
    return /*#__PURE__*/React.createElement(Link, {
      key: link.url,
      to: link.url
    }, link.name);
  }));
}

export default LinkList;